import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../services/api'

export default function Verify() {
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { state } = useLocation()
  const email = state?.email
  const { t } = useTranslation()

  const handleVerify = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const res = await api.post('/auth/verify', { email, code })
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('user', JSON.stringify(res.data.user))
      const exp = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString()
      document.cookie = `token=${res.data.token}; expires=${exp}; path=/; SameSite=Strict`
      navigate('/dashboard')
    } catch {
      setError(t('verify.error'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:'#f8f9fa',padding:20}}>
      <div style={{backgroundColor:'#fff',borderRadius:20,padding:40,width:'100%',maxWidth:400,boxShadow:'0 4px 24px rgba(0,0,0,0.06)'}}>
        <div style={{fontSize:48,textAlign:'center'}}>📧</div>
        <h1 style={{fontSize:24,fontWeight:600,textAlign:'center',margin:'8px 0 4px',color:'#1a1a1a'}}>{t('verify.title')}</h1>
        <p style={{fontSize:15,textAlign:'center',color:'#888',marginBottom:32}}>{t('verify.subtitle')} <strong>{email}</strong></p>
        <form onSubmit={handleVerify} style={{display:'flex',flexDirection:'column',gap:12}}>
          {error && <div style={{backgroundColor:'#fff0f0',color:'#e74c3c',padding:'12px 16px',borderRadius:10,fontSize:14}}>{error}</div>}
          <input
            style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:24,outline:'none',textAlign:'center',letterSpacing:8,fontWeight:600}}
            type="text"
            placeholder="000000"
            value={code}
            onChange={e => setCode(e.target.value)}
            maxLength={6}
            required
          />
          <button style={{padding:14,borderRadius:12,border:'none',backgroundColor:'#2D7A3A',color:'#fff',fontSize:16,fontWeight:600,cursor:'pointer',marginTop:8}} type="submit" disabled={loading}>
            {loading ? t('verify.loading') : t('verify.submit')}
          </button>
        </form>
      </div>
    </div>
  )
}
